import React from 'react';
import { ErrorContext } from '../../Context/Error/errorContext';

export default function GlobalErrorToasts() {
  const { errors, removeError } = React.useContext(ErrorContext);
  if (!errors.length) return null;
  return (
    <div
      style={{
        position: 'fixed',
        top: 10,
        right: 10,
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        maxWidth: '320px',
      }}
    >
      {errors.map((err) => (
        <div
          key={err.id}
          style={{
            background: '#721c24',
            color: '#fff',
            padding: '12px 14px',
            borderRadius: 4,
            boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
            fontSize: 13,
            lineHeight: '1.4',
          }}
        >
          <div style={{ fontWeight: 'bold', marginBottom: 4 }}>Error</div>
          {err.message && <div>{err.message}</div>}
          {err.correlationId && (
            <div style={{ marginTop: 4, fontFamily: 'monospace' }}>
              cid: {err.correlationId}{' '}
              <button
                style={{ marginLeft: 6 }}
                onClick={() => {
                  try {
                    navigator.clipboard.writeText(err.correlationId);
                  } catch (_) {}
                }}
              >
                Copy
              </button>
            </div>
          )}
          <button
            style={{
              marginTop: 6,
              background: 'transparent',
              border: '1px solid #fff',
              color: '#fff',
              fontSize: 11,
              padding: '2px 6px',
              cursor: 'pointer',
              borderRadius: 3,
            }}
            onClick={() => removeError(err.id)}
          >
            Dismiss
          </button>
        </div>
      ))}
    </div>
  );
}
